import { SxProps, Theme } from "@mui/material";
import { getContrastColor } from "theme/utils";

export default (theme: Theme) =>
  ({
    Parameters: {
      header: {
        height: "calc(7 * var(--rhythm))",
        boxSizing: "border-box",
      },

      img: {
        height: "calc(6 * var(--rhythm))",
        width: "calc(6 * var(--rhythm))",
      },

      description: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "calc(6 * var(--rhythm))",
        fontSize: "var(--font-size-xs)",
      },
    },

    Results: {
      container: {
        border: "none",
      },

      table: {
        border: "none",
      },

      head: {
        height: "calc(3 * var(--rhythm))",
        background: "var(--color-black)",
        th: {
          color: "var(--color-white)",
        },
      },
    },

    Roadway: {
      head: {
        height: "calc(3 * var(--rhythm))",
        background: "var(--color-blue-light) !important",
      },
    },

    BorderArea: {
      head: {
        height: "calc(3 * var(--rhythm))",
        background: "var(--color-blue-light) !important",
      },
    },

    Selection: {
      row: {
        height: "calc(3 * var(--rhythm))",
        background: "var(--color-primary) !important",
      },

      label: {
        fontWeight: "bold",
        color: getContrastColor(),
        // color: getContrastColor(),
      },

      cells: {
        padding: 0,
      },

      group: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
      },

      radio: {
        "&.MuiRadio-root": {
          "&::before": {
            content: "''",
            position: "absolute",
            display: "inline-block",
            width: "var(--rhythm)",
            height: "var(--rhythm)",
            background: "var(--color-white)",
            border: "2px solid var(--color-black)",
            borderRadius: "50%",
            zIndex: 1,
          },
          "&.Mui-checked::before": {
            display: "none",
          },
        },
        ".MuiSvgIcon-root": {
          fill: "var(--color-white)",
        },
      },
    },
  }) as Record<string, Record<string, SxProps<Theme>>>;
